/**
 * ADA: button + aria-controls accordion (replaces details/summary for collapsible content).
 * Only binds .accordion__toggle — not cart-freegift or accordion-desc-bundle.
 */
(function () {
  function getPanel(button) {
    const id = button?.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function setExpanded(button, expanded) {
    const panel = getPanel(button);
    if (!button || !panel) return;

    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function toggle(button) {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    setExpanded(button, !isOpen);
  }

  // Document-level delegation: early return means non-accordion clicks are untouched
  // (preventDefault only runs for .accordion__toggle matches).
  function onClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('.accordion__toggle[aria-controls]');
    if (!button) return;

    // Buttons are type="button"; still preventDefault if nested in a form.
    event.preventDefault();
    toggle(button);
  }

  document.addEventListener('click', onClick);
})();
